export const ContentPlaceholder = (props) => {
    const addedStyle = props.style ? props.style : {};
    const text = props.text ? props.text : "";

    const style = {
        width: "100%",
        background: "blue",
        color: "white",
        minHeight: "70px",
        padding: "15px 10px",
        boxSizing: "border-box",
        ...addedStyle,
    };

    return (
        <div
            className={props.className}
            style={style}
            data-testid="content-placeholder"
        >
            {text}
        </div>
    );
};

export default ContentPlaceholder;
